
import { defineComponent, onMounted, ref } from "vue";
import { Collapse } from "bootstrap/dist/js/bootstrap";

export default defineComponent({
  name: "Planets",
  setup() {
    const isOpen = ref(true);
    const planets = [
      { name: "mercury", class: "planet mercury" },
      { name: "venus", class: "planet venus" },
      { name: "earth", class: "planet earth" },
      { name: "mars", class: "planet mars" },
      { name: "jupiter", class: "planet jupiter" },
      { name: "saturn", class: "planet saturn" },
      { name: "uranus", class: "planet uranus" },
      { name: "neptune", class: "planet neptune" },
    ];

    let bsCollapse = undefined;

    onMounted(() => {
      const id = document.getElementById("PlanetNav");
      bsCollapse = new Collapse(id);
    });

    const closeNav = () => {
      (bsCollapse || new Collapse()).toggle();
      isOpen.value = false;
    };

    return { planets, isOpen, closeNav };
  },
});
